module.exports = __webpack_public_path__ + "static/media/chip-20.2fb9e1bc.png";